/** @format */

import PropTypes from "prop-types";
import { Link as RouterLink } from "react-router-dom";
// material
import { Box } from "@mui/material";
import React from "react";

import logo from "../static/logo-infomedia-white.png"; // relative path to image

// ----------------------------------------------------------------------

Logo.propTypes = {
  sx: PropTypes.object,
};

export default function Logo({ sx }) {
  return (
    <RouterLink to="/">
      <Box
        style={{
          objectFit: "contain",
        }}
        component="img"
        src={logo}
        sx={{ width: "100%", ...sx }}
      />
    </RouterLink>
  );
}
